<template>
  <div>
    <v-main class="pt-0">
      <PageHeaderSection />
      <PageAboutSection />
      <PageDownloadSection />
      <PagePricingSection />
      <PageContactSection />
    </v-main>
    <v-scale-transition>
      <v-btn
        fab
        v-show="fab"
        v-scroll="onScroll"
        fixed
        bottom
        right
        color="primary"
        dark
        @click="toTop"
        class="scroll-top-btn"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-scale-transition>
    <PageFooterSection />
  </div>
</template>

<script>
import PageHeaderSection from "@/features/landing/components/HomeSection.vue";
import PageAboutSection from "@/features/landing/components/AboutSection.vue";
import PageDownloadSection from "@/features/landing/components/DownloadSection.vue";
import PagePricingSection from "@/features/landing/components/PricingSection.vue";
import PageContactSection from "@/features/landing/components/ContactSection.vue";
import PageFooterSection from "@/features/landing/components/Footer.vue";

export default {
  components: {
    PageHeaderSection,
    PageAboutSection,
    PageDownloadSection,
    PagePricingSection,
    PageContactSection,
    PageFooterSection,
  },

  data: () => ({
    fab: null,
    color: "",
    flat: null,
  }),

  created() {
    const top = window.pageYOffset || 0;
    if (top <= 60) {
      this.color = "transparent";
      this.flat = true;
    }
  },

  watch: {
    fab(value) {
      if (value) {
        this.color = "primary";
        this.flat = false;
      } else {
        this.color = "transparent";
        this.flat = true;
      }
    },
  },

  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>

<style scoped>
.scroll-top-btn {
  z-index: 10;
}
</style>
